<template>
  <div class="source">
    <el-row>
      <el-col :span="24">
        <el-form ref="form"  label-width="150px" label-position="left" class="tabcard">
          <el-form-item label="上传大文件" class="yyzz_upload">
            <el-upload
              class="avatar-uploader"
              drag
              action=""
              :on-success="fnUploadSuccess"
              :headers="uploadHeaders"
              :show-file-list="true"
              :http-request="fnUploadRequest"
              :limit="files"
              :on-error="OnBlError"
              :before-upload="BeforeBlUpload">
            </el-upload>
            <el-progress type="circle" :percentage="uppercent" style="margin-top:30px;"></el-progress>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Utils from '../../util/utils'
var OSS = require('ali-oss')
export default {
  name: 'fileUpload',
  props: {
    data_extra: {
      type: Object,
      required: true
    },
    accept: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      uploadUrl: '',
      uploadFileLength: 0,
      uploadFileSuccess: 0,
      uploadFileNames: [],
      uploadFileName: [],
      fileList: [],
      bucketpath: '/videos',
      files: 100,
      uploadHeaders: {
        authorization: ''
      },
      uppercent: 0,
      disabled: false
    }
  },
  methods: {
    randomString (num) {
      let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
      let res = ''
      for (let i = 0; i < num; i++) {
        var id = Math.ceil(Math.random() * 35)
        res += chars[id]
      }
      return res
    },

    /**
     * 创建oss客户端对象
     * @returns {*}
     */
    createOssClient () {
      return new Promise((resolve, reject) => {
        let client = new OSS({
          region: 'oss-cn-beijing',
          accessKeyId: 'LTAIKSVtBrgCLQUR',
          accessKeySecret: 'IKxBaWkQeDn2MeKwBQGXGs2rV3xTRz',
          bucket: 'jingsite'
        })
        resolve(client)
      })
    },
    /**
     * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
     * @author   yangxiaoshuo
     * @param    {object}   option [上传选项]
     * @return   {null}   [没有返回]
     */
    async fnUploadRequest (option) {
      var that = this
      let file = option.file
      const self = this
      return new Promise((resolve, reject) => {
        let date = Utils.dateFormat(new Date(), 'yyyyMMdd') // 当前时间
        console.log(date)
        let dateTime = Utils.dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
        let randomStr = self.randomString(4)//  4位随机字符串
        let extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
        console.log(dateTime)
        console.log(randomStr)
        console.log(extensionName)
        let fileName = that.bucketpath + '/' + file.name // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.createOssClient().then(client => {
          // 异步上传,返回数据
          resolve({
            fileName: file.name,
            fileUrl: fileName
          })
          // 上传处理
          // 分片上传文件
          client.multipartUpload(fileName, file, {
            progress: function (p) {
              let e = {}
              e.percent = Math.floor(p * 100)
              // console.log('Progress: ' + p)
              option.onProgress(e)
              that.uppercent = e.percent
              console.log(e.percent)
            }
          }).then((val) => {
            if (val.res.statusCode === 200) {
              option.onSuccess(val)
              return val
            } else {
              option.onError('上传失败')
            }
          }, err => {
            option.onError('上传失败')
            reject(err)
          })
        }).catch(errinfo => {
        })
      })
    },
    /**
     * @description [fnUploadSuccess 文件上传成功的函数]
     * @author   shanshuizinong
     * @return   {null}  [没有返回]
     */
    async fnUploadSuccess (file) {
      console.log(file)
      // TODO
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/protest/BigFileUpload.vue